export default "__VITE_ASSET__03b60b76__"